function pickFirstString(...values) {
  for (const value of values) {
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
      return String(value);
    }
  }
  return null;
}

function resolveImageCandidate(value, depth = 0) {
  if (!value || depth > 4) {
    return null;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return pickFirstString(value);
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const nested = resolveImageCandidate(item, depth + 1);
      if (nested) {
        return nested;
      }
    }
    return null;
  }

  if (typeof value !== 'object') {
    return null;
  }

  if (typeof value.toHexString === 'function') {
    const asHex = pickFirstString(value.toHexString());
    if (asHex) {
      return asHex;
    }
  }

  const keys = Object.keys(value);
  if (keys.length > 0 && keys.every((key) => key === '$oid' || key === '_id' || key === 'id')) {
    return pickFirstString(value.$oid, value._id, value.id);
  }

  const direct = pickFirstString(
    value.$oid,
    value.image_id,
    value.imageId,
    value.imageID,
    value.image_url,
    value.imageUrl,
    value.url,
    value.src,
    value.path,
    value.secure_url,
    value.thumbnail,
    value.thumbnailUrl,
    value.thumbnail_url,
    value.userProfileImage,
    value.user_profile_image,
  );
  if (direct) {
    return direct;
  }

  const nestedCandidates = [
    value.image_id,
    value.imageId,
    value.imageID,
    value.user_image,
    value.userImage,
    value.profile_image,
    value.profileImage,
    value.owner_image,
    value.ownerImage,
    value.avatar,
    value.image,
    value.file,
    value.asset,
    value.userProfileImage,
    value.user_profile_image,
  ];

  for (const candidate of nestedCandidates) {
    const nested = resolveImageCandidate(candidate, depth + 1);
    if (nested) {
      return nested;
    }
  }

  return null;
}

function normalizeTypeToken(value) {
  if (value === undefined || value === null) {
    return '';
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const token = normalizeTypeToken(item);
      if (token) {
        return token;
      }
    }
    return '';
  }

  if (typeof value === 'object') {
    const nested = (
      value.user_type
      ?? value.type
      ?? value.profileType
      ?? value.profile_type
      ?? value.typeOfAccount
      ?? value.type_of_account
      ?? value.ownerType
      ?? value.__t
      ?? null
    );
    if (nested !== undefined && nested !== null) {
      return normalizeTypeToken(nested);
    }
    return '';
  }

  return String(value).toLowerCase().trim();
}

export function resolveUserProfileImage(...candidates) {
  for (const candidate of candidates) {
    const resolved = resolveImageCandidate(candidate);
    if (resolved) {
      return resolved;
    }
  }
  return null;
}

export function resolveUserProfileTypeWithFallback(fallback = 'collector', ...candidates) {
  for (const candidate of candidates) {
    const normalized = normalizeTypeToken(candidate);
    if (!normalized) {
      continue;
    }
    if (normalized === 'artist_request' || normalized.includes('artist')) {
      return 'artist';
    }
    if (normalized === 'gallery_request' || normalized.includes('gallery')) {
      return 'gallery';
    }
    if (normalized.includes('collector')) {
      return 'collector';
    }
    if (['user', 'member', 'standard', 'fan', 'visitor', 'client'].includes(normalized)) {
      return 'collector';
    }
  }
  return fallback;
}
